/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Sample_UpdatedInputs */

const en_samples_edit_sample_updated = /** @type {(inputs: Samples_Edit_Sample_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample updated`)
};

const es_samples_edit_sample_updated = /** @type {(inputs: Samples_Edit_Sample_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestra actualizada`)
};

/**
* | output |
* | --- |
* | "Sample updated" |
*
* @param {Samples_Edit_Sample_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_sample_updated = /** @type {((inputs?: Samples_Edit_Sample_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Sample_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_sample_updated(inputs)
	return es_samples_edit_sample_updated(inputs)
});